import { render, staticRenderFns } from "./vulnerabilities.vue?vue&type=template&id=57aa3fb6&scoped=true"
import script from "./vulnerabilities.vue?vue&type=script&lang=js"
export * from "./vulnerabilities.vue?vue&type=script&lang=js"
import style0 from "./vulnerabilities.vue?vue&type=style&index=0&id=57aa3fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa3fb6",
  null
  
)

export default component.exports